import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import Modal from 'react-modal';
import * as yup from 'yup';
import { useState } from 'react';

// material ui
import {
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

// graphql
import { useCreateTelegramReportMutation, useTelegramReportTypesQuery } from '@/generated/graphql';

// interfaces
import { ITelegramReportTypeTable, mapGQLTelegramReportType, type ICreateTelegramReportInput } from '@/shared/interfaces';

import { MdOutlinePostAdd } from 'react-icons/md';

interface IUsherProps {
  refetchData: () => void;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CreateReport = ({ open, setOpen, refetchData }: IUsherProps) => {
  const [reportTypes, setReporTypes] = useState<ITelegramReportTypeTable[]>([]);
  const [reportTypeValue, setReportTypeValue] = useState<string>('');

  const getReportTypes = useTelegramReportTypesQuery({
    variables: { first: 9999 },
    onCompleted(data) {
      const mappedData = data.telegramReportTypes.nodes.map((x) => mapGQLTelegramReportType(x));

      const mappedTableData: ITelegramReportTypeTable[] = mappedData.map((x) => ({
        id: x.id,
        name: x.name,
        description: x.description,
        createdAt: x.createdAt,
      }));

      setTimeout(() => {
        setReporTypes(mappedTableData);
      }, 100);
    },
  });

  const handleClose = () => setOpen(false);

  const schema = yup
    .object({
      name: yup.string().required(),
      telegramReportTypeId: yup.string().required(),
      description: yup.string().notRequired(),
    })
    .required();

  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ICreateTelegramReportInput>({
    resolver: yupResolver(schema),
  });

  const [createReportMutation] = useCreateTelegramReportMutation();

  const onSubmit = async (dataInput: ICreateTelegramReportInput) => {
    const { name, description, telegramReportTypeId } = dataInput;

    const input: ICreateTelegramReportInput = {
      name,
      telegramReportTypeId,
      description,
    };
    console.log('🚀 ~ onSubmit ~ input:', input);

    const { data } = await createReportMutation({
      variables: {
        input,
      },
    });

    if (data) console.log(data);
    if (errors) console.log(errors);
    refetchData();
    handleClose();
    reset();
  };

  return (
    <>
      <Modal
        isOpen={open}
        onRequestClose={handleClose}
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            color: 'inherit',
            backgroundColor: 'rgba(25, 25, 25, 0.75)',
          },
          content: {
            width: '440px',
            overflow: 'unset',
            position: 'absolute',
            margin: '0.1% auto',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            padding: 0,
            marginRight: '-50%',
            transform: 'translate(-50%, -48vh)',
            border: '0px',
            background: 'transparent',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
          },
        }}>
        <Box
          sx={{
            backgroundColor: '#fff',
            overflow: 'unset',
            borderRadius: '5px',
          }}
          mt={9}>
          <Box sx={{ px: 5, py: 2 }} alignItems={'center'}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography gutterBottom variant="subtitle2" m={0}>
                Create Report
              </Typography>
              <MdOutlinePostAdd fontSize={18} />
            </Stack>
          </Box>
          <Divider />

          <Box px={5} pt={2} pb={2}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid>
                <FormControl fullWidth sx={{ mt: 5 }} variant="standard">
                  <TextField label="Name" InputLabelProps={{ shrink: true }} variant="standard" {...register('name')} />
                </FormControl>
                <FormControl sx={{ width: '100%', mt: 3 }} size="small">
                  <InputLabel id="demo-select-small-label">Report Type</InputLabel>
                  <Select
                    {...register('telegramReportTypeId')}
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={reportTypeValue}
                    label="Report Type"
                    onChange={(event) => {
                      setReportTypeValue(event.target.value);
                    }}>
                    {reportTypes.map((reportType, reportTypeIndex) => (
                      <MenuItem key={reportTypeIndex} value={reportType.id}>
                        {reportType.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mt: 2 }} variant="standard">
                  <TextField
                    id="standard-multiline-static"
                    label="Description"
                    multiline
                    rows={3}
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                    {...register('description')}
                  />
                </FormControl>
              </Grid>
              <Grid container justifyContent={'end'} mt={5}>
                <Button
                  type="submit"
                  size="small"
                  variant="contained"
                  sx={{
                    background: 'grey',
                    fontSize: 10,
                    fontWeight: 600,
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    textTransform: 'unset',
                  }}
                  onClick={handleClose}>
                  Cancel
                </Button>
                <Button
                  sx={{
                    ml: 1,
                    fontSize: 10,
                    fontWeight: 600,
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    paddingTop: '8px',
                    paddingBottom: '8px',
                    textTransform: 'unset',
                  }}
                  type="submit"
                  size="small"
                  variant="contained">
                  Create
                </Button>
              </Grid>
            </form>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
